// extracted by mini-css-extract-plugin
export default {"content":"cartDrawer_content__h-QWb","items":"cartDrawer_items__5pdz7","footer":"cartDrawer_footer__0faB1"};